import React, { useState } from "react";
import styled from "styled-components";
import { defaultUser } from "../../assets/images";
import CustomInput from "../reusable/CustomInput";
import { toast } from "react-toastify";
import { IoClose } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";

import ButtonLoader from "../reusable/ButtonLoader";

const MainDiv = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99;

  > .close_modal {
    position: fixed;
    top: 15px;
    right: 15px;
    width: 30px;
    height: 30px;
    border-radius: 8px;
    font-size: 18px;
    cursor: pointer;
    border: 1px solid #f2f2f2;
    color: #f2f2f2;
    background-color: transparent;

    &:hover {
      border: 1px solid #f2f2f2;
      color: #121d40;
      background-color: #f2f2f2;
    }
  }

  > form {
    background-color: #121d40;
    border-radius: 16px;
    padding: 30px;
    box-sizing: border-box;
    min-width: 290px;

    @media screen and (max-width: 575px) {
      padding: 20px;
    }

    > img {
      width: 200px;
      height: 200px;
      border-left: 1px solid #f2f2f2;
      border-right: 1px solid #f2f2f2;
      border-radius: 100%;
      background: #081336;
      display: block;
      margin: 0 auto 20px;
      object-fit: contain;

      @media screen and (max-width: 575px) {
        width: 150px;
        height: 150px;
      }
    }

    > button {
      font-size: 16px;
      margin: 0 auto;
      width: fit-content;
      padding-right: 20px;
      padding-left: 20px;
    }

    > button.remove_pic_btn {
      background: transparent;
      color: #f2f2f2;
      font-size: 16px;
      border: none;
      display: block;
      margin: 20px auto 0;
      cursor: pointer;
      padding: 0;

      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const UploadProfilePicForm = ({ setUploadProfileModal }) => {
  const dispatch = useDispatch();
  const [profile, setAvatar] = useState("");
  const [avatarPreview, setAvatarPreview] = useState(defaultUser);
  const loading = false;

  const handleInputChange = (e) => {
    if (e.target.name === "profile") {
      const reader = new FileReader();
      reader.onload = () => {
        if (reader.readyState === 2) {
          setAvatarPreview(reader.result);
          setAvatar(reader.result);
        }
      };
      reader.readAsDataURL(e.target.files[0]);
    }
  };

  const profileUploadSubmit = (e) => {
    e.preventDefault();
    if (profile !== "") {
      toast.warning("We're working on it");
    } else {
      toast.error("Please Select a file...");
    }
  };

  return (
    <MainDiv className="upload_profile_pic">
      {!loading && (
        <button
          className="close_modal"
          onClick={() => setUploadProfileModal(false)}
        >
          <IoClose />
        </button>
      )}
      <form encType="multipart/form-data">
        <img src={avatarPreview} alt="Alpha Regiment Avatar Preview" />
        <CustomInput
          type="file"
          name="profile"
          accept="image/*"
          onChange={handleInputChange}
        />
        <button
          onClick={profileUploadSubmit}
          disabled={loading ? true : false}
          title={loading ? <ButtonLoader /> : "Upload"}
        >{loading ? <ButtonLoader /> : "Upload"}</button>
        {/* <button className="remove_pic_btn">Remove profile picture</button> */}
      </form>
    </MainDiv>
  );
};

export default UploadProfilePicForm;
